export default __webpack_public_path__ + "static/media/blog-03.1bced0df.jpg";